import { getJrnDefaultComponent } from '../getJrn/getJrnDefaultComponent.js'
import getOutboundProxyController from './getOutboundProxyController.js'
import _module from 'module.js'
import _ from 'lodash'

let getOutboundProxyComponent = _.cloneDeep(getJrnDefaultComponent)
getOutboundProxyComponent.controller = getOutboundProxyController

_module.component('getOutboundProxy', getOutboundProxyComponent)
